"use strict";

exports.__esModule = true;
exports.DeviceDataItemQueryController = DeviceDataItemQueryController;
var _react = _interopRequireDefault(require("react"));
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
var _APIQueryController = require("../../API/APIQueryController");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Executes a device data item query and provides the results via render prop.
 */
function DeviceDataItemQueryController(props) {
  var query = props.query,
    children = props.children;
  var dataAccessor = _react["default"].useContext(_DataAccessorContext.DataAccessorContext);
  return /*#__PURE__*/_react["default"].createElement(_APIQueryController.APIQueryController, {
    load: function load() {
      return dataAccessor.getRawConnectData(query);
    },
    query: query
  }, children);
}